// Modules
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { ThemeProvider } from '@dasa-health/alma-react'

// Application
import { partnerTypes } from 'constants/partnersTypes'
import { navTheme } from 'styles/global'
import { getQueryParamsValue } from 'utils'
import { RedirectModal } from 'components/RedirectModal'
import { ROUTES_PATH } from 'constants/routesPath'
import { PhasedLoginFFType } from 'redesign/typings/featureFlags'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'
import { defaultConfig } from 'modules/RemoteConfig/defaultConfig'
import { LIVIA_LS_KEY } from 'constants/app'
import { useLoginHook } from 'hooks'

interface ParamsBrand {
    logo: string
    brandName: string
}

export const PartnerRedirect: React.VFC = () => {
    const { signOut } = useLoginHook()
    const location = useLocation()
    const history = useHistory()
    const { getConfigByName } = useRemoteConfig()
    const [paramsBrand, setParamsBrand] = useState<ParamsBrand>()
    const { visibility: phasedLoginVisibility } =
        ((getConfigByName('NAV_PHASED_LOGIN') as unknown) as PhasedLoginFFType) || JSON.parse(defaultConfig.jsons.NAV_PHASED_LOGIN)
    const loginPath = useMemo(() => (phasedLoginVisibility ? ROUTES_PATH.SIGN_IN : ROUTES_PATH.LOGIN), [phasedLoginVisibility])

    const homePath = useMemo(() => (getConfigByName('AUTH_REDIRECT_LOGIN') as string) || defaultConfig.strings.AUTH_REDIRECT_LOGIN, [
        getConfigByName,
    ])

    function checkLogin() {
        const AuthData = JSON.parse(localStorage.getItem(LIVIA_LS_KEY) || '{}')
        const { signed } = AuthData
        signed && signOut()
    }

    const isSafari = useMemo(() => {
        const { userAgent } = navigator
        return userAgent.toLowerCase().includes('safari/') && !userAgent.toLowerCase().includes('chrome/')
    }, [])

    const redirect = useCallback(() => {
        const formattedUrl = new URLSearchParams()
        const brandId = getQueryParamsValue(location, 'brandId')
        const productIds = getQueryParamsValue(location, 'productIds')
        const redirectTo = (getQueryParamsValue(location, 'redirectTo') || homePath).replace(/^\/v2/, '')
        const type = getQueryParamsValue(location, 'type')
        if (brandId) {
            formattedUrl.append('brandId', brandId)
        }
        if (productIds) {
            formattedUrl.append('productIds', productIds)
        }
        if (type) {
            formattedUrl.append('type', type)
        }
        const params = encodeURIComponent(formattedUrl.toString())
        if (redirectTo) {
            history.replace(`${loginPath}?redirectTo=${redirectTo}?${params}`)
        } else {
            history.replace(`${loginPath}?${params}`)
        }
    }, [history, homePath, location, loginPath])

    useEffect(() => {
        const brandId = getQueryParamsValue(location, 'brandId')

        if (brandId && partnerTypes[brandId]) {
            sessionStorage.setItem('@LiviaRedirect', JSON.stringify({ brandId }))
            setParamsBrand({ logo: partnerTypes[brandId].localLogo, brandName: partnerTypes[brandId].labName })
            return
        }
        history.replace(loginPath)
    }, [history, location, loginPath])

    useEffect(() => {
        if (!isSafari) {
            setTimeout(() => {
                redirect()
            }, 8000)
        }
    }, [redirect, isSafari])

    useEffect(() => {
        checkLogin()
    }, [])

    return (
        <ThemeProvider theme={navTheme}>
            <RedirectModal
                isSafari={isSafari}
                labelButton="Ir para o Nav Dasa"
                paramsBrand={paramsBrand}
                redirect={redirect}
                subtitle={!isSafari ? 'Você está sendo redirecionado.' : 'Você será redirecionado.'}
                title="O seu atendimento online agora é feito pelo Nav Dasa"
            />
        </ThemeProvider>
    )
}
